import { defineMessages } from 'react-intl';

export const messages: {
	appSwitcher: { defaultMessage: string; description: string; id: string };
} = defineMessages({
	appSwitcher: {
		defaultMessage: 'Switch apps and sites',
		description:
			'Label for the top navigation button that opens the app switcher. Read out by screen readers and shown in the button tooltip.',
		id: 'global-top-navigation.app-switcher.appSwitcher',
	},
});
